export const choiceSequence = `query {
    choiceSequence {
        family
        choiceIDs
    }
}`
